import { default as LoginPage } from './LoginPage';

export default LoginPage;
